// Shared by routing_cascade_controller.js and review_routing_cascade_controller.js:
// same CSRF-token + JSON PATCH request, same "couldn't save" toast on failure.
export async function patchJson(url, body) {
  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
    },
    body: JSON.stringify(body)
  })
  if (!response.ok) throw new Error("save failed")
  return response
}

export function notifySaveFailure() {
  window.toast("Couldn't save — retry", { kind: "error" })
}
